export default __webpack_public_path__ + "static/media/asian-elderly.55e24b5b.png";